import React, { Component } from "react";
import Emart from "../../Experience/Contents/Emart/Emart";

class Emartrouter extends Component {
  render() {
    return (
      <div>
        <Emart></Emart>
      </div>
    );
  }
}

export default Emartrouter;
